function formatDeliveryCodeAndBatch(deliverCode, batch) {
    const normalizedDeliverCode = deliverCode == null ? "" : deliverCode;
    const normalizedBatch = batch == null ? "" : batch;
    return `${normalizedDeliverCode}/${normalizedBatch}`;
}

module.exports = formatDeliveryCodeAndBatch;
